import { z } from 'zod';

export const SecureDataState = z.enum(['ACTIVE', 'CANCELLED', 'OUTDATED']);

export type SecureDataState = z.infer<typeof SecureDataState>;

export const secureDataOf = <T extends z.ZodType>(data: T) => {
  return z.discriminatedUnion('state', [
    z.object({
      state: z.literal('ACTIVE'),
      data,
    }),
    z.object({
      state: z.literal('CANCELLED'),
    }),
    z.object({
      state: z.literal('OUTDATED'),
    }),
  ]);
};
